var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tab-layout', {
    attrs: {
      "tabs": _vm.tabs,
      "isLoading": _vm.isLoading
    },
    on: {
      "update:tab": _vm.setActiveTab
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "block": "",
            "text": ""
          },
          on: {
            "click": function click() {
              return _vm.documentTable.createDocument();
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("sign.uploadDocument")) + " ")])];
      },
      proxy: true
    }])
  }, [[_vm.activeTab ? _c('document-table', {
    key: 'document-table-' + _vm.activeTab.id,
    ref: "documentTable",
    attrs: {
      "refs": [_vm.ref],
      "tags": _vm.activeTab.tag ? [_vm.activeTab.tag] : []
    }
  }) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }